<template>
  <div :id="componentId" class="curls-in-salon">
    <h1 v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }" class="salon-product-title">
      {{ curlSalonData.curlInSalon_title }}
    </h1>
    <h2
      v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
      class="salon-product-sub-title"
    >
      {{ curlSalonData.curlInSalon_subTitile }}
    </h2>
    <img
      v-if="curlSalonData.curlInSalon_image"
      v-animate-onscroll.repeat="{ down: 'animated zoomIn' }"
      class="salon-main-image"
      :src="curlSalonData.curlInSalon_image.Src"
      :alt="curlSalonData.curlInSalon_image.Alt"
    />
    <div
      v-if="curlSalonData.curlInSalon_description"
      v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
      :class="descriptionBlockStyle(curlSalonData)"
    >
      <div v-if="curlSalonData.curlInSalon_isDescriptionQuote" class="quote-box-component">
        <span class="quotes">&#8220;</span>
        <slot name="quote-description"></slot>
        <span class="quotes">&#8221;</span>
      </div>
      <slot v-else name="text-description"></slot>
    </div>
    <h2 v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }" class="salon-service-title">
      {{ curlSalonData.curlInSalon_productSectionTitle }}
    </h2>
    <h3
      v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
      class="salon-service-sub-title"
    >
      {{ curlSalonData.curlInSalon_productName }}
    </h3>
    <img
      v-if="curlSalonData.curlInSalon_productImage"
      v-animate-onscroll.repeat="{ down: 'animated zoomIn' }"
      class="salon-main-image"
      :src="curlSalonData.curlInSalon_productImage.Src"
      :alt="curlSalonData.curlInSalon_productImage.Alt"
    />
    <a
      v-if="curlSalonData.curlInSalon_ctaText"
      v-animate-onscroll.repeat="{ down: 'animated zoomIn' }"
      :href="curlSalonData.curlInSalon_ctaLink"
      class="curl-service-button ripple-animation ripple-animation--black"
      :class="{ 'overlap-cta': curlSalonData.curlInSalon_isCtaOverlap }"
      @click="pushCtaDataLayer()"
      >{{ curlSalonData.curlInSalon_ctaText }}</a
    >
    <div
      v-if="curlSalonData.curlInSalon_productDescription"
      :class="{ 'overlap-cta': curlSalonData.curlInSalon_isCtaOverlap }"
    >
      <slot name="description"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'curl-in-salon',
  props: {
    curlSalonData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      componentId: 'curl-in-salon',
    };
  },
  mounted() {
    document.addEventListener('scroll', this.menuHighlight);
  },
  methods: {
    menuHighlight() {
      const componentBlock = document.getElementById(this.componentId);
      if (componentBlock) {
        const checkOffset = componentBlock.offsetTop - 120;
        if (window.pageYOffset >= checkOffset) {
          window.eventBus.$emit('summary-menu-highlight', this.componentId);
        }
      }
    },
    pushCtaDataLayer() {
      try {
          dataLayer.push({ //eslint-disable-line
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: 'store locator',
          eventAction: 'find a salon',
          eventLabel: '',
          event_name: 'where_to_buy',
          product_info: '',
        });
      } catch (error) {
        console.warn(error);
      }
    },
    descriptionBlockStyle(curlSalonData) {
      const bgcolor = curlSalonData.curlInSalon_isBgDescriptionWhite
        ? 'desc-white-bg'
        : 'desc-grey-bg';
      const overlap = curlSalonData.curlInSalon_descriptionNotOverlap
        ? 'product-desc-non-overlap'
        : 'product-desc-block-overlap';
      return `${overlap} ${bgcolor}`;
    },
  },
};
</script>
